module.exports = __webpack_public_path__ + "img/8虚拟阳台双人内舱房.322df80.jpg";